/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component, Inject } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { LoggerService } from '../../../../shared/services/logger.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'dash-gis-markup-text-dialog',
    templateUrl: './markup-text-dialog.component.html',
})
export class MarkupTextDialogComponent {
    public markupText: UntypedFormGroup;

    constructor(
        private logger: LoggerService,
        private dialogRef: MatDialogRef<MarkupTextDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        this.markupText = new UntypedFormGroup({
            textControl: new UntypedFormControl(''),
        });
    }

    public submitText() {
        const textValue = this.markupText.value['textControl'];
        this.dialogRef.close(textValue);
    }

    public cancel() {
        this.dialogRef.close(null);
    }
}
